/* LGCY custom motion layer v2.2 — reveals replay in both scroll directions,
   parallax, drift, marquee.
   Two-observer pattern: reveal as soon as an element enters the viewport,
   but only RESET it once it is fully out of view plus a 30% buffer —
   otherwise partially-visible elements flicker off while on screen.
   v2.2: earlier trigger (threshold 0.05, no bottom inset) and tighter
   stagger so fast scrollers never sit on a blank section. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var enterIO = null;
  var resetIO = null;
  function ensureObservers() {
    if (enterIO) return;
    enterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lgcy-inview');
        }
      });
    }, { threshold: 0.05, rootMargin: '0px' });
    resetIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          entry.target.classList.remove('lgcy-inview');
        }
      });
    }, { threshold: 0, rootMargin: '30% 0px 30% 0px' });
  }

  function initReveals(root) {
    root = root || document;
    root.querySelectorAll('[data-lgcy-stagger]').forEach(function (wrap) {
      var kids = wrap.children;
      for (var i = 0; i < kids.length; i++) {
        kids[i].classList.add('lgcy-reveal');
        kids[i].style.setProperty('--lgcy-delay', Math.min(i * 45, 270) + 'ms');
      }
    });
    var els = root.querySelectorAll('.lgcy-reveal');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('lgcy-inview'); });
      return;
    }
    ensureObservers();
    els.forEach(function (el) {
      if (el.dataset.lgcyObs) return;
      el.dataset.lgcyObs = '1';
      enterIO.observe(el);
      resetIO.observe(el);
    });
  }

  /* ---- parallax + drift ---- */
  var parallaxEls = [];
  var driftEls = [];
  var ticking = false;

  function collectMotionEls() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-lgcy-parallax]'));
    driftEls = Array.prototype.slice.call(document.querySelectorAll('[data-lgcy-drift]'));
  }

  function applyMotion() {
    ticking = false;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var host = el.parentElement;
      var rect = host.getBoundingClientRect();
      if (rect.bottom < -100 || rect.top > vh + 100) return;
      var speed = parseFloat(el.getAttribute('data-lgcy-parallax')) || 0.1;
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      el.style.translate = '0 ' + (progress * speed * -100).toFixed(1) + 'px';
    });
    driftEls.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return;
      var f = parseFloat(el.getAttribute('data-lgcy-drift')) || 0.1;
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      el.style.translate = (progress * f * -400).toFixed(1) + 'px 0';
    });
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(applyMotion);
    }
  }

  /* ---- marquee speed normalization ---- */
  function initMarquees(root) {
    root = root || document;
    root.querySelectorAll('[data-lgcy-marquee]').forEach(function (track) {
      var group = track.querySelector('.lgcy-marquee__group');
      if (!group) return;
      var speed = parseFloat(track.getAttribute('data-speed')) || 70; /* px per second */
      var w = group.offsetWidth;
      if (w > 0) {
        track.style.setProperty('--lgcy-mq-duration', (w / speed).toFixed(2) + 's');
      }
    });
  }

  /* ---- hero load-in ---- */
  function initHero() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        document.querySelectorAll('.lgcy-hero').forEach(function (h) {
          h.classList.add('lgcy-loaded');
        });
      });
    });
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { initMarquees(); }, 200);
  }

  function boot() {
    initReveals();
    collectMotionEls();
    initMarquees();
    initHero();
    if (!reduceMotion) {
      window.addEventListener('scroll', onScroll, { passive: true });
      applyMotion();
    }
    window.addEventListener('resize', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* re-init inside the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
    collectMotionEls();
    initMarquees(e.target);
    initHero();
  });
})();